import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import AdminPanel, { adminConfigs } from "@thewebops/admin-panel";
import configureStore, { history } from "configureStore";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router/immutable";
import { adminConfigs as adminCustomConfigs } from "adminConfigs";
import { startChatViewing } from "utils/chatViewing";
import { startOpenConversationListener } from "utils/openConversation";
import { startPushSound } from "utils/playNotificationSound";
import { startPushWorker } from "utils/pushWorker";
import { startInstallPromptCapture } from "utils/installApp";
import ChatPageStyles from "components/ChatPageStyles";

adminConfigs.init(adminCustomConfigs);
startChatViewing();
startOpenConversationListener();
startPushSound();
startPushWorker();
// Before Chrome fires its install prompt, which the install card shows instead of Chrome's own bar.
startInstallPromptCapture();

export const store = configureStore();

const MOUNT_NODE = document.getElementById("root");

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <>
        <ChatPageStyles />
        <AdminPanel />
      </>
    </ConnectedRouter>
  </Provider>,
  MOUNT_NODE,
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
